import React from 'react';

// The sticky title bar at the top of every page, with optional actions on the right.
const PageHeader = ({ title, before, after, actions }) => (
  <div className="title-container">
    <div className="title-left">
      {before}
      <h1 className="name-header">{title}</h1>
      {after}
    </div>
    {actions && <div>{actions}</div>}
  </div>
);

export default PageHeader;
